import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=376aa1ce&"
import script from "./OrderSearch.vue?vue&type=script&lang=ts&"
export * from "./OrderSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports